var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#B8F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2126 6.25C17.3314 6.25 18.7501 7.7375 18.7501 9.95V15.0569C18.7501 17.2625 17.3314 18.75 15.2126 18.75H9.79387C7.67512 18.75 6.25012 17.2625 6.25012 15.0569V9.95C6.25012 7.7375 7.67512 6.25 9.79387 6.25H15.2126ZM15.1126 10.625C14.9001 10.4125 14.5501 10.4125 14.3376 10.625L11.7564 13.2063L10.6626 12.1125C10.4501 11.9 10.1001 11.9 9.88762 12.1125C9.67512 12.325 9.67512 12.6687 9.88762 12.8875L11.3751 14.3687C11.4814 14.475 11.6189 14.525 11.7564 14.525C11.9001 14.525 12.0376 14.475 12.1439 14.3687L15.1126 11.4C15.3251 11.1875 15.3251 10.8438 15.1126 10.625Z",
    fill: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDoneIcon);
export default __webpack_public_path__ + "static/media/order-done-icon.4369260cdbea94600ea131d366e4d06a.svg";
export { ForwardRef as ReactComponent };